export default __webpack_public_path__ + "static/media/route-filled-lime.e5543e7a.svg";